import React from "react";
import { Route, Navigate, RouteProps } from "react-router-dom";

    // components
    import PrivateRoute from "./PrivateRoute";

    // import Root from './Root';

    // lazy load all the views

    // auth
const Login = React.lazy(() => import("../pages/auth/Login"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const ResetPasword = React.lazy(() => import("../pages/auth/ResetPassword"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));

const Maintenance = React.lazy(() => import("../pages/other/Maintenance"));
const Error404 = React.lazy(() => import("../pages/error/Error404"));
const Error500 = React.lazy(() => import("../pages/error/Error500"));

const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Security = React.lazy(() => import("../pages/Security"));
const AgentDashboard = React.lazy(() => import("../pages/AgentDashboard"));
const Chat = React.lazy(() => import("../pages/Chat"));
const AwaitingOfferPackage = React.lazy(() => import("../pages/Supervisor/flow/AwaitingOfferPackage"));

const Tickets = React.lazy(() => import("../pages/Ticket"));
    const TicketAddEdit = React.lazy(
      () => import("../pages/Ticket/add-edit/index")
    );

    export interface RoutesProps {
      path: RouteProps["path"];
      name?: string;
      element?: RouteProps["element"];
      route?: any;
      exact?: boolean;
      icon?: string;
      header?: string;
      permissions?: string[];
      children?: RoutesProps[];
    }

    // root routes
    const rootRoute: RoutesProps = {
      path: "/",
      exact: true,
      element: <Navigate to="/chat" />
    };

    // dashboards

    const dashboardRoutes: RoutesProps[] = [{
      path: "/security",
      name: "Security",
      icon: "shield",
      element: <Security />
    }, {
      path: "/chat",
      name: "Chat",
      icon: "message-square",
      element: <Chat />
    }, {
      path: "/dashboard",
      name: "Dashboard",
      icon: "airplay",
      element: <AgentDashboard />
    }, {
      path: "/dashboard/awaiting-offer-packages",
      name: "Awaiting Offer Packages",
      icon: "airplay",
      element: <AwaitingOfferPackage />
    }, {
      path: "/dashboard/:customerType/:chatroomId",
      name: "Chat",
      icon: "airplay",
      element: <Chat />
    }, {
      path: "/dashboard/:customerType/:chatroomId/:action",
      name: "Chat",
      icon: "airplay",
      element: <Chat />
    }, {
      path: "/dashboard/:customerType/:chatroomId/:action/:step",
      name: "Chat",
      icon: "airplay",
      element: <Chat />
    }, {
      path: "/dashboard/:customerType/:chatroomId/:action/:step/:additionalRef",
      name: "Chat",
      icon: "airplay",
      element: <Chat />
    }, {
      path: "/dashboard/tickets",
      name: "Tickets",
      permissions: ["agent_ticket_support"],
      element: <Tickets />,
      children: [
        {
          path: "/dashboard/tickets/edit/:id",
          name: "Edit Ticket",
          permissions: ["agent_ticket_support"],
          element: <TicketAddEdit />
        }
      ]
    }
    ];


    // auth
    const authRoutes: RoutesProps[] = [
      {
        path: "/auth/login",
        name: "Login",
        element: <Login />
      },
      {
        path: "/auth/logout",
        name: "Logout",
        element: <Logout />
      },
      {
        path: "/auth/forget-password",
        name: "Forget Password",
        element: <ForgetPassword />
      },
      {
        path: "/auth/reset-password",
        name: "Reset Password",
        element: <ResetPasword />
      }
    ];

    // public routes
    const otherPublicRoutes = [
      {
        path: "/maintenance",
        name: "Maintenance",
        element: <Maintenance />
      },
      {
        path: "/error-404",
        name: "Error - 404",
        element: <Error404 />
      },
      {
        path: "/error-500",
        name: "Error - 500",
        element: <Error500 />
      }
    ];
    // flatten the list of all nested routes
    const flattenRoutes = (routes: RoutesProps[]) => {
      let flatRoutes: RoutesProps[] = [];

      routes = routes || [];
      routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== "undefined") {
          flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
      });
      return flatRoutes;
    };

    // All routes
    const authProtectedRoutes: any = [
      rootRoute,
      ...dashboardRoutes/*
      extrapagesRoutes,
      uiRoutes,*/
    ];
    const publicRoutes = [...authRoutes, ...otherPublicRoutes];

    const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
    const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
    export {
      publicRoutes,
      authProtectedRoutes,
      authProtectedFlattenRoutes,
      publicProtectedFlattenRoutes
    };
